import { inject, Injectable } from "@angular/core";
import { CanMatch, Route, UrlSegment } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { filter, map, Observable } from "rxjs";

import { CatalogueSelectors } from "src/app/core/store/selectors";
import { Category } from "../models/category.model";

@Injectable({
  providedIn: "root",
})
export class CanMatchCategory implements CanMatch {
  private store = inject(Store);
  categories$: Observable<Category[]>;
  categories!: Category[];

  constructor() {
    this.categories$ = this.store.pipe(
      select(CatalogueSelectors.getCategories),
      filter((categories) => !!categories.length),
      map((categories) => this.flatten([], categories)),
      map((categories) =>
        categories.filter(
          (category: Category) => category.entity === "category",
        ),
      ),
    );

    // this.categories$.subscribe((categories) => {
    //   this.categories = categories;
    //   // console.log({ categories });
    // });
  }

  flatten(into: Category[], node: Category | Category[] | null | undefined): Category[] {
    if (node == null) {
      return into;
    }
    if (Array.isArray(node)) {
      return node.reduce((acc, n) => this.flatten(acc, n), into);
    }
    into.push(node);
    return this.flatten(into, node.children);
  }

  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean> {
    return this.categories$.pipe(
      map(
        (categories) =>
          segments.length === 0 ||
          (segments.length === 1 && segments[0].path === "") ||
          !!categories?.filter(
            (category) => category.slug === segments[0]?.path,
          ).length,
      ),
    );
  }
}
